import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@pages/HomePage.vue'
import TutorialPage from '@pages/TutorialPage.vue'
import MeetingEndPage from '@pages/MeetingEndPage.vue'
import LanguagePage from '@pages/LanguagePage.vue'
import { stringIsEmpty } from '@ipevo-rd/service-web-utils'
import { useInfoStore } from '@shared-store'


// 路由設定
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // 首頁
    {
      path: '/',
      name: 'home',
      component: HomePage,
      props: (route) => ({ ...route.query }),
    },
    // 選擇語言頁面
    {
      path: '/language',
      name: 'language',
      component: LanguagePage,
    },
    // 翻譯畫面
    {
      path: '/?s=:shortID',
      name: 'tutorial',
      component: TutorialPage,
    },
    // 會議結束頁面
    {
      path: '/meeting-end',
      name: 'meetingEnd',
      component: MeetingEndPage,
    },
  ],
})

router.beforeEach((to, from, next) => {
  // 取得Session ID
  const { sessionID } = useInfoStore()
  // 取得名稱
  const name = to.name as string
  // 要過濾的路徑
  const filterName = ['meetingEnd', 'tutorial']

  // 判斷當前路徑是否在過濾路徑中
  if (filterName.includes(name)) {
    // 如果Session ID不存在，則導向首頁
    if (stringIsEmpty(sessionID)) {
      next('/')
    } else { //如果Session ID存在，則放行
      next()
    }
  } else {
    // 如果當前路徑不在過濾路徑中，則放行
    next()
  }
})

export default router
